import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

import { InterfacePafIcon } from '../paf-icon/paf-icon.custom';

@Component({
  shadow: true,
  styleUrl: 'paf-result-alert.scss',
  tag: 'paf-result-alert',
})

export class PafResultAlert implements ComponentInterface {

  /** The name of the cus-him icon */
  @Prop() public iconName!: InterfacePafIcon['cusHim'];

  /** The description of the alert */
  @Prop() public description!: string;

  public render(): HTMLDivElement {
    return (
      <div class='result-alert'>

        <paf-icon
          class='icon'
          variant='cus-him-info'
          name={this.iconName}
          data-testid='icon'
        />

        <span
          class='description'
          data-testid='description'
        >{this.description}</span>
      </div>
    );
  }
}
